import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import styles from "./PatientName.module.css";

/**
 * Hashmark 변환 유틸리티 (컴포넌트 외부로 분리하여 성능 최적화)
 */
const formatHashmark = (str) => {
    if (!str) return "";
    return String(str).replace(/hashmark/g, "#");
};

function PatientName(props) {
    // 1. 기존의 형태를 유지하기 위한 상태 (동작은 그대로 유지)
    const [visibleFirst, setVisibleFirst] = useState(false);

    // 2. 이벤트 버블링 방지 (Link 클릭과 div 클릭이 겹칠 수 있음)
    const handleToggle = (e) => {
        // 만약 추후 하위 메뉴가 생길 경우를 대비한 상태 전환 로직 유지
        setVisibleFirst(!visibleFirst);
    };

    return (
        <div className={styles.PatientListSecond}>
            <div onClick={handleToggle}>
                {/* 기존 로직 유지: 클릭 시 상세 페이지로 이동 
                    props.name이 hashmark 문자열을 포함할 경우 변환하여 출력
                */}
                <Link 
                    to={`/patient/${props.name}`} 
                    className={styles.PatientListSecondTitle}
                >
                    {formatHashmark(props.name)}
                </Link>
            </div>
        </div>
    );
}

export default PatientName;